<template lang="pug">
#graficoPrevisaoChuvaTemperatura(v-loading='isLoading')
    apex-charts.component.apexcharts-canvas(
        type='line',
        height='300',
        :options='options',
        :series='series',
        ref='chart'
    )
</template>

<script>
import { graficoPrevisaoChuvaTemperatura } from '../../../utils/layouts/graficos';
import ApexCharts from 'vue-apexcharts';

import MonitoramentoService from '@/services/MonitoramentoService';

export default {
    name: 'GraficoPrevisaoChuvaTemperatura',

    components: {
        ApexCharts
    },

    data() {
        return {
            dadosClimaticos: null,
            isLoading: false,
            series: [],
            options: {}
        };
    },

    mounted() {
        this.isLoading = true;
        MonitoramentoService.monitoramentoClimatico(
            this.$route.params.idAreaMonitorada
        )
            .then(({ data }) => {
                this.dadosClimaticos = data.dados;
                this.configure();
            })
            .catch(() => {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramento.historico.agricola.ocorreuUmErroAoBuscarDadosClimaticos')
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        configure() {
            const dadosPrecipitacao = this.dadosClimaticos.find(
                d => d.tipo === 'PRECIPITACAO'
            ).dados;
            const dadosTemperaturaMaxima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MAXIMA'
            ).dados;
            const dadosTemperaturaMinima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MINIMA'
            ).dados;

            const baseOptions = graficoPrevisaoChuvaTemperatura();
            this.options = Object.assign(
                {},
                baseOptions
            );

            this.options.xaxis.categories = [];
            this.options.xaxis.categories.push(
                ...dadosPrecipitacao.map(d =>
                    new Date(d.data).toLocaleDateString('pt-BR')
                )
            );

            this.series = [
                {
                    name: this.$t('mensagens.monitoramento.historico.agricola.precipitacao'),
                    type: 'column',
                    data: dadosPrecipitacao.map(d => d.valor)
                },
                {
                    name: this.$t('mensagens.monitoramento.historico.agricola.temperaturaMaxima'),
                    type: 'line',
                    data: dadosTemperaturaMaxima.map(d => d.valor)
                },
                {
                    name: this.$t('mensagens.monitoramento.historico.agricola.temperaturaMinima'),
                    type: 'line',
                    data: dadosTemperaturaMinima.map(d => d.valor)
                }
            ];

            const max =
                this.series[1].data.reduce((a, b) => Math.max(a, b)) + 10;
            const min = 0;

            /* Deixando escala dos gráficos de temperatura iguais */
            this.options.yaxis[1].max = max;
            this.options.yaxis[1].min = min;

            this.options.yaxis[2].max = max;
            this.options.yaxis[2].min = min;

            this.$refs.chart.updateOptions(this.options);
        }
    }
};
</script>
<style>
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
